import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import getCaretCoordinates from 'textarea-caret';
import insertText from './insertText';
import ItemList from './ItemList';
export default class BasicEditorDriver {
  constructor(dom, params) {
    _defineProperty(this, "el", void 0);
    this.el = document.createElement('textarea');
    this.build(dom, params);
  }
  build(dom, params) {
    this.el.className = params.classNames.join(' ');
    this.el.disabled = params.disabled;
    this.el.placeholder = params.placeholder;
    this.el.value = params.value;
    const callInputListeners = e => {
      params.inputListeners.forEach(listener => {
        listener();
      });
      e.redraw = false;
    };
    this.el.oninput = e => {
      params.oninput(this.el.value);
      callInputListeners(e);
    };
    this.el.onclick = callInputListeners;
    this.el.onkeyup = callInputListeners;
    this.el.addEventListener('keydown', e => {
      this.keyHandlers(params).toArray().forEach(handler => handler(e));
    });
    dom.append(this.el);
  }
  keyHandlers(params) {
    const items = new ItemList();
    items.add('submit', function (e) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
        params.onsubmit();
      }
    });
    return items;
  }
  moveCursorTo(position) {
    this.setSelectionRange(position, position);
  }
  getSelectionRange() {
    return [this.el.selectionStart, this.el.selectionEnd];
  }
  getLastNChars(n) {
    const value = this.el.value;
    return value.slice(Math.max(0, this.el.selectionStart - n), this.el.selectionStart);
  }
  insertAtCursor(text) {
    this.insertAt(this.el.selectionStart, text);
  }
  insertAt(pos, text) {
    this.insertBetween(pos, pos, text);
  }
  insertBetween(selectionStart, selectionEnd, text) {
    this.setSelectionRange(selectionStart, selectionEnd);
    const cursorPos = selectionStart + text.length;
    insertText(this.el, {
      text,
      selectionStart: cursorPos,
      selectionEnd: cursorPos
    });
  }
  replaceBeforeCursor(start, text) {
    this.insertBetween(start, this.el.selectionStart, text);
  }
  setSelectionRange(start, end) {
    this.el.setSelectionRange(start, end);
    this.focus();
  }
  getCaretCoordinates(position) {
    const relCoords = getCaretCoordinates(this.el, position);
    return {
      top: relCoords.top - this.el.scrollTop,
      left: relCoords.left
    };
  }

  // DOM Interactions

  /**
   * Set the disabled status of the editor.
   */
  disabled(disabled) {
    this.el.disabled = disabled;
  }

  /**
   * Focus on the editor.
   */
  focus() {
    this.el.focus();
  }

  /**
   * Destroy the editor
   */
  destroy() {
    this.el.remove();
  }
}
flarum.reg.add('core', 'common/utils/BasicEditorDriver', BasicEditorDriver);